import React, {useState} from "react";
import BarekamInputMultilingual from "../../../../../../pages/components/input-multilingual/barekam-input-multilingual";
import {DialogContent, Grid} from "@mui/material";
import {Message, MessageSections} from "../../../../../../pages/components/message/message";
import {StandardDialogFooter} from "../../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import {getMessage} from "../../../../../../pages/shared/helper-functions";
import {useAppSelector} from "../../../../../../redux/store";
import {ProvinceModel} from "../../../../../../pages/shared/models/provinceModel";
import {BarekamSelect} from "../../../../../../pages/components/select/select";
import provinceService from "../../../../../../services/province-service";
import {BarekamMenuItem, SelectedBarekamMenuItem} from "../../../../../../pages/components/select/styled/orders";
import {AxiosError} from "axios";
import {mapValidationErrors} from "../../../../../../pages/user/settings/personal-info/personal-info.service";

const EditProvince = ({provinceData, onCancel}: {provinceData: ProvinceModel, onCancel: () => void}) => {
    const {countries} = useAppSelector(state => state.staticDataReducer);
    const [modifiedProvince, setModifiedProvince] = useState(provinceData);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    function handleChange(field: 'name' | 'country', value: any) {
        setModifiedProvince(prevState => {
            if (field === 'country') {
                const country = countries.find(country => country.countryId === value);

                if (country) {
                    prevState[field] = country;
                }
            } else {
                prevState[field] = value;
            }

            return {...prevState}
        })
    }

    function validateData() {
        const errors = {} as {[key: string]: string};

        if (!modifiedProvince.name || Object.keys(modifiedProvince.name).length < 1) {
            errors['name'] = 'required';
        }
        if (!modifiedProvince.country) {
            errors['country'] = 'required';
        }
        return errors;
    }

    function handleSave() {
        const errors = validateData();
        setErrors(errors);

        if (Object.keys(errors).length === 0) {
            if (modifiedProvince.provinceId) {
                provinceService.editProvince(provinceData.provinceId, modifiedProvince)
                    .then(() => onCancel())
                    .catch(reason => {
                        if (reason instanceof AxiosError) {
                            setErrors(mapValidationErrors(reason));
                        }
                    });
            } else {
                provinceService.createProvince(modifiedProvince)
                    .then(() => onCancel())
                    .catch(reason => {
                        if (reason instanceof AxiosError) {
                            setErrors(mapValidationErrors(reason));
                        }
                    });
            }
        }
    }

    return (
        <>
            <DialogContent>
                <Grid container rowSpacing={'1rem'} columnSpacing={'1rem'}>
                    <BarekamInputMultilingual multilingualText={modifiedProvince.name || {}}
                                              labelKey={'name'}
                                              field={'name'}
                                              onChange={(name) => handleChange('name', name)}
                                              errors={errors}/>


                    <Grid item xs={12}>
                        <BarekamSelect
                            variant={'outlined'}
                            label={getMessage('country', MessageSections.MAIN, messageCache, languageId)}
                            value={modifiedProvince?.country?.countryId || ''}
                            onChange={(value) => handleChange('country', value.target.value)}
                            type={"standard"}
                            error={!!errors['country']}
                            errorMessage={errors['country'] && getMessage(errors['country'], MessageSections.MAIN, messageCache, languageId)}>
                            {countries.map((country, index) => {
                                if (country.countryId === modifiedProvince?.country?.countryId) {
                                    return (
                                        <SelectedBarekamMenuItem value={country.countryId}
                                                                 key={index}>
                                            {country.name[languageId]}
                                        </SelectedBarekamMenuItem>
                                    )
                                } else {
                                    return (
                                        <BarekamMenuItem value={country.countryId}
                                                         key={index}>
                                            {country.name[languageId]}
                                        </BarekamMenuItem>
                                    );
                                }
                            })}
                        </BarekamSelect>
                    </Grid>
                </Grid>
            </DialogContent>

            <StandardDialogFooter onCancel={() => onCancel()}
                                  onSave={() => handleSave()}
                                  saveLabel={<Message messageKey={'save'} sectionId={MessageSections.MAIN}/>}/>
        </>
    );
}

export default EditProvince;